module.exports = new __parcel__URL__("atlassian.f31899ab.png").toString();